<template>
  <svg
    width="24"
    height="23"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_71_120334)">
      <mask
        id="mask0_71_120334"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <path d="M0.664062 0H20.6641V20H0.664062V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_71_120334)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.8334 1.66667C17.5301 1.66667 17.2499 1.76191 17.0059 2.00593L9.24027 9.77167L8.55885 12.1078L10.8951 11.4264L18.6608 3.66075C18.8396 3.48192 19 3.10981 19 2.83333C19 2.21023 18.4564 1.66667 17.8334 1.66667ZM15.8274 0.827421C16.4168 0.238116 17.1366 0 17.8334 0C19.3769 0 20.6667 1.28976 20.6667 2.83333C20.6667 3.55684 20.3271 4.35142 19.8393 4.83926L11.9226 12.7559C11.8236 12.855 11.7012 12.9274 11.5667 12.9667L7.56669 14.1333C7.27458 14.2185 6.95926 14.1377 6.7441 13.9226C6.52894 13.7074 6.44816 13.3921 6.53336 13.1L7.70001 9.1C7.73924 8.96558 7.81171 8.84317 7.91076 8.74408L15.8274 0.827421Z"
          fill="#237276"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.664062 5.83335C0.664062 3.53979 2.53716 1.66669 4.83073 1.66669H9.83073C10.291 1.66669 10.6641 2.03979 10.6641 2.50002C10.6641 2.96025 10.291 3.33335 9.83073 3.33335H4.83073C3.45763 3.33335 2.33073 4.46025 2.33073 5.83335V15.8334C2.33073 17.2064 3.45763 18.3334 4.83073 18.3334H14.8307C16.2038 18.3334 17.3307 17.2064 17.3307 15.8334V10.8334C17.3307 10.3731 17.7038 10 18.1641 10C18.6243 10 18.9974 10.3731 18.9974 10.8334V15.8334C18.9974 18.1269 17.1243 20 14.8307 20H4.83073C2.53716 20 0.664062 18.1269 0.664062 15.8334V5.83335Z"
          fill="#237276"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_71_120334">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.664062)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
